module.exports = __webpack_public_path__ + "static/img/AlexDeMinaur.6c6bd1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AlexDeMinaur.jpg
// module id = 4IAk
// module chunks = 0